<master-detail-block>

    <ng-template masterFilterContent>
        <module-header [ngClass]="$safeNavigationMigration(context?.displayMode)" [host]="host" [formControl]="moduleHeaderForm"></module-header>
    </ng-template>


    <file-list *masterContent [context]="context" [entity]="entity" [groups]="groups" [view]="viewEntity" (addFile)="onAddFile($event)" (itemExpand)="onExpand($event)" (itemUpdated)="onAttachmentUpdated($event)"></file-list>

    <ng-container *ngIf="context?.displayMode === FilesDisplayMode.Picker">

        <div class="files-footer" *masterFooterContent>
            <!-- <w-button label="Cancel" (onClick)="onCancel()"></w-button> -->
            <w-button displayStyle="Primary" size="Medium" [command]="addSelectedCommand"></w-button>
        </div>

    </ng-container>


    <ng-container [ngSwitch]="$safeNavigationMigration(dialogService?.dialog$) | async">
        <ng-container *ngSwitchCase="DialogType.Edit">

            <ng-template masterDetailEditor>
                <file-details-editor [context]="context" [attachment]="attachment" (attachmentUpdated)="onAttachmentUpdated($event)" (delete)="onDeleteActivity($event)" [attachmentContext]="attachmentContext" />
            </ng-template>

        </ng-container>

    </ng-container>

    <ng-container [ngSwitch]="$safeNavigationMigration(dialogService?.modalDialog$) | async">
        <ng-template masterDetailModalEditor>

            <ng-container *ngSwitchCase="DialogType.Edit">
                <file-details-editor display="modal" [context]="context" [attachment]="attachment" (attachmentUpdated)="onAttachmentUpdated($event)" (delete)="onDeleteActivity($event)" [attachmentContext]="attachmentContext" />
            </ng-container>

            <ng-container *ngSwitchCase="DialogType.New">
                <file-upload-editor [context]="context" (save)="onCreateActivity($event)" />
            </ng-container>

            <ng-container *ngSwitchCase="DialogType.View">
                <file-details-preview [context]="context" [attachment]="$safeNavigationMigration(activeService?.activeItem?.attachment)" [attachmentContext]="attachmentContext" />
            </ng-container>

            <ng-container *ngSwitchCase="DialogType.Media">
                <file-details-preview [context]="context" [attachment]="expandedAttachment" />
            </ng-container>

        </ng-template>

    </ng-container>

</master-detail-block>